module.exports = __webpack_public_path__ + "static/whitepapper_collage-49a8929cbb0bd15aac4b2b9acb18ddfb.jpg";